import axios from "axios";

function resolveBackendUrl() {
    const envUrl = process.env.REACT_APP_BACKEND_URL;
    // On the browser, if REACT_APP_BACKEND_URL is empty or points to a host
    // that differs from the current page host, fall back to same-origin.
    // This makes production deployments (where backend is served behind the
    // same domain as the frontend) work even if the env var was baked at
    // build time with a stale preview URL.
    if (typeof window !== "undefined") {
        try {
            if (!envUrl) return window.location.origin;
            const u = new URL(envUrl);
            if (u.host !== window.location.host) return window.location.origin;
            return envUrl;
        } catch {
            return window.location.origin;
        }
    }
    return envUrl || "";
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

// ─── Impersonation (SuperAdmin read-only preview) ────────────────────
// When the admin picks "Impersonate this employer" we stash the target
// company id in localStorage; every subsequent request carries the
// X-Impersonate-Company header so the backend swaps the effective user.
// The banner rendered in AppShell exposes the "Exit" button which clears
// this key. Persisted in localStorage so a page refresh keeps the preview.
export const IMPERSONATE_STORAGE_KEY = "pw_impersonate_company_id";

export function getImpersonatedCompanyId() {
    if (typeof window === "undefined") return null;
    try { return window.localStorage.getItem(IMPERSONATE_STORAGE_KEY); }
    catch { return null; }
}

export function setImpersonatedCompanyId(cid) {
    if (typeof window === "undefined") return;
    try {
        if (cid) window.localStorage.setItem(IMPERSONATE_STORAGE_KEY, cid);
        else window.localStorage.removeItem(IMPERSONATE_STORAGE_KEY);
    } catch { /* ignore */ }
}

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Attach the impersonation header on every request when active.
api.interceptors.request.use((config) => {
    const cid = getImpersonatedCompanyId();
    if (cid) {
        config.headers = config.headers || {};
        config.headers["X-Impersonate-Company"] = cid;
    }
    return config;
});

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || "Something went wrong";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .join(", ");
    }
    if (detail?.msg) return detail.msg;
    return String(detail);
}

export function scoreColor(score) {
    if (score >= 75) return "text-emerald-600 bg-emerald-50 border-emerald-200";
    if (score >= 50) return "text-amber-600 bg-amber-50 border-amber-200";
    return "text-red-600 bg-red-50 border-red-200";
}
